export const containerStyles = {
  width: "100%",
  // maxWidth:"1200px",
  backgroundImage: "linear-gradient(180deg, #CEE5FD, #FFF)",
  backgroundSize: "100% 20%",
  backgroundRepeat: "no-repeat",
  pt: { xs: 14, sm: 5 },
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

// export const containerStyles = {
//   // Set the width and maxWidth properties to make the box full width
  
//   //maxWidth: "none", // Remove the maxWidth restriction
//   backgroundImage: "linear-gradient(180deg, #CEE5FD, #FFF)",
//   backgroundSize: "100% 20%",
//   backgroundRepeat: "no-repeat",
//   pt: { xs: 14, sm: 5 },
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   color: "red",
//   // width: { xs: "100%", sm: "100%", md: "100%", lg: "100%", xl: "100%" },
//   width: "100% !important"


// };




export const tableContainerStyles = {
  marginTop: "50px",
width: "100%",
maxWidth: {
      xs: "270px", // Full width on extra small screens
      sm: "325px", // 250px width on small screens
      md: "1000px", // 250px width on medium screens
      // lg: "750px", // 250px width on large screens
      // xl: "250px", // 250px width on extra large screens
    },
  overflowX: "auto",
};
// export const tableContainerStyles = {
//   marginTop: "50px",
//   maxWidth: {
//     xs: "450px", // Full width on extra small screens
//     sm: "510px", // 250px width on small screens
//     // md: "950px", // 250px width on medium screens
//     // lg: "750px", // 250px width on large screens
//     // xl: "250px", // 250px width on extra large screens
//   },
//   overflowX: "auto",
// };


export const tableStyles = {
  // minWidth: "450px",
  // maxWidth: "750px",
 // width: "100%",
};

export const tableCellStyles = {
  border: "1px solid black",
  fontWeight: "bold",
  textAlign: 'center'
};

export const tableRowStyles = {
  border: "1px solid black",
  padding: '3px',
  textAlign: 'center'
};

export const arrowTypographyStyles = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  justifyContent: "start",
  alignSelf: "center",
  textAlign: "center",
  fontSize: "clamp(1rem, 8vw, 2rem)",
  borderTop: "1px solid",
  borderColor: "black",
  paddingTop: "8px",
  width: "100%",
  boxSizing: "border-box",
   color: "primary.main",
  //  paddingLeft: { xs: "0", md: "20px" },
};

export const activeStyle = {
  background: "red", // Change to the desired background color
  color: "white", // Change to the desired text color
  border: "1px solid black",
  padding: '3px',
  textAlign: 'center'
};
